// extracted by mini-css-extract-plugin
export default {"scroll_btn":"ScrollButton_scroll_btn__D+Ikr"};